module.exports = __webpack_public_path__ + "img/filter.a09b2d14.svg";